export default "__VITE_ASSET__CKqeIzdt__"